export default __webpack_public_path__ + "static/media/certificateee.7edf10ef.jpg";